import {Component, OnInit} from '@angular/core';
import {AccountService} from "../../../services/account.service";
import {UserMachineSubscription} from "../../../model/custom/machine/user-machine-subscription";
import {AuthGuard} from "../../../common/auth-guard.service";

@Component({
  selector: 'app-account-subscriptions',
  templateUrl: './account-subscriptions.component.html',
  styleUrls: ['./account-subscriptions.component.scss']
})
export class AccountSubscriptionsComponent implements OnInit {

  public machineSubscriptions: UserMachineSubscription[];
  public totalSubscriptions: number;
  public loadingSubscriptions: boolean;

  public rows: number = 10;
  public first: number = 0;


  constructor(private accountService: AccountService,
              public authGuard: AuthGuard) {
  }

  ngOnInit(): void {
    this.loadSubscriptions();
  }

  private loadSubscriptions(): void {
    this.loadingSubscriptions = true;
    this.machineSubscriptions = new Array(this.rows);
    this.accountService.getUserSubscriptions()
      .subscribe(response => {
        let tempMachineSubscriptions = response.machineSubscriptions;
        tempMachineSubscriptions.sort((a, b) =>
          new Date(a.startDate) < new Date(b.startDate) ? 1 : -1);
        this.machineSubscriptions = response.machineSubscriptions;
        this.totalSubscriptions = this.machineSubscriptions.length;
        this.loadingSubscriptions = false;
      });
  }

}
